const ApiURL = {
  _login: "v1/auth/login",
  _loginVerify: "v1/auth/login/verify",

  _accessToken: "v1/auth/access-token-login",
  _refreshToken: "v1/auth/refresh-token",

  _firmware: "/v1/device/firmware",
  _firmwareUpload: "/v1/device/firmware/upload",

  _appRelease: "/v1/app/releases",
  __appReleaseUpload: "/v1/app/releases/upload",
  
  _role: "v1/roles",
  _updateRole: "v1/users/update-role",
  _user: "v1/users",
  _userUploadProfilePicture: "v1/users/upload-profile-picture",
  _uploadFloorPlan: "v1/campuses/floors/upload-floor-plan",
  _floorPlan: "v1/campuses/floors",
  _dronenest: "v1/dronenest",
  _drones: "v1/dronenest/drones",
  _doors: "v1/dronenest/doors",
  _doorsUpdateState: "v1/dronenest/doors/update-state",

  _dashboard: "v1/external-admin-dashboard/",
  _district: "v1/districts",
  _districtUploadLogo: "v1/districts/upload-logo",
  _campuses: "v1/campuses",
  _building: "v1/buildings",
  _tag: "v1/tags",
  _bulkTag: "v1/tags/bulk-tag",
  _tagIcon: "v1/tags/icons",
  _admin: "/v1/users/admins",
  _userOtherDetail: "v1/users/update-profile",
  _updateUserDetail: "/v1/users/update-user-detail",
  _userInvite: "v1/users/invite",
  _userReInvite: "v1/users/resend-invite-email",
  
  _uploadChunk: "/file-sharing/files/large-upload",
};

export default ApiURL;
